import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BsrComponent } from './bsr/bsr.component';




const routes: Routes = [
  {//BSR  color of the bar #002f5b  https://www.bipresents.com/pa3930
   path: ':id',
   component: BsrComponent
  },

  {
    path: '',
    redirectTo: '/', //use this line for production
    pathMatch: 'full'
  }


];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

